import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const CareersTeaser = () => (
  <section data-testid="careers-teaser" className="bg-white py-20 md:py-24">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-8 rounded-3xl border border-slate-200 bg-slate-50 p-10 transition-[box-shadow,border-color] duration-500 hover:border-electric/25 hover:shadow-lg md:flex-row md:items-center">
          <div className="flex items-start gap-5">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-electric/10">
              <Users className="h-6 w-6 text-electric" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="font-display text-2xl font-medium tracking-tight text-slate-900 md:text-3xl">
                Careers at Prata Technologies
              </h2>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-600">
                Interested in building AI and automation products for real
                businesses across the UK and India? We'd love to hear from you.
              </p>
            </div>
          </div>
          <Link
            to="/careers"
            data-testid="careers-teaser-cta"
            className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-navy-950 px-7 py-3.5 text-sm font-medium text-white transition-[background-color,box-shadow,transform] duration-300 hover:scale-[1.02] hover:bg-electric hover:shadow-[0_0_24px_rgba(37,99,235,0.4)] active:scale-95"
          >
            View Careers
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CareersTeaser;
